const id_sales_quotation = {
    "": "penawaran",
    add: "buat penawaran",

    message: {
        reject_title: "Apakah Anda yakin untuk membatalkan penawaran?",
        reject_text: "Masukkan alasan pembatalan penawaran.",
    },

    error: {
        create: "Gagal membuat penawaran.",
        edit: "Gagal mengubah penawaran.",

        reject: "Gagal membatalkan penawaran.",
        approve: "Gagal mengonfirmasi penawaran.",
        done: "Gagal menyelesaikan penawaran.",
    },

    success: {
        create: "Berhasil membuat penawaran.",
        edit: "Berhasil mengubah penawaran.",

        reject: "Berhasil membatalkan penawaran.",
        approve: "Berhasil mengonfirmasi penawaran.",
        done: "Berhasil menyelesaikan penawaran.",
    },
}

export default id_sales_quotation;